import React, { useRef, useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { GetNonPurchaseParties } from './function';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPrefix,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setStationID,
  setStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import GeniusReportsDate from '../utility/component/reportDate';
import {
  setListStationMasterModalStatus,
} from '../utility/Redux/modal';
import ModListStationMaster from '../utility/component/modals/modListStationMaster';
import GeniusTableReports from '../utility/component/geniusComponents/geniusTableforReports';
import ReactToPrint from 'react-to-print';
import IsLocalData from '../utility/functions/ceckLocalData';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';

const NonPurchasingParties = () => {
  const fromDate = useSelector(selectreportFromDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const toDate = useSelector(selectreportToDate);
  const [toDateFocus, setToDateFocus] = useState(false);
  const userType = useSelector(selectUserType);
  const [list, setList] = useState([]);
  const printRef = useRef();
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);

  const okButton = () => {
      GetNonPurchaseParties(
        prefix,
        dispatch,
        token,
        setList,
      
      );
   
  };

  const columns = [
    {
      field: 'NAME',
      accessor: 'NAME',
      width: windowWidth <= 768 ? 180 : 260,
      align: 'left',
      renderHeader: () => <div>Name</div>,
    },
    {
      field: 'ADDRESS',
      accessor: 'ADDRESS',
      width: windowWidth <= 768 ? 220 : 320,
      align: 'left',
      renderHeader: () => <div>Address</div>,
    },
    {
      field: 'CITY',
      accessor: 'CITY',
      width: windowWidth <= 768 ? 160 : 220,
      align: 'left',
      renderHeader: () => <div>City</div>,
    },
    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      width: windowWidth <= 768 ? 140 : 180,
      align: 'left',
      renderHeader: () => <div>Mobile</div>,
    },
  ];

  useEffect(() => {
    const elseFunc = () => {
      if (userType !== 'USER') {
        dispatch(setStationID(''));
        dispatch(setStationName(''));
      }
    };

    const callback = (details, data) => {
      setList(data);
  
    };

    IsLocalData('nonPurchasingParty', callback, elseFunc);
  }, []);

  return (
    <div className="h-full w-full p-2 text-sm">
      {window.innerWidth <= 500 ? (
        <>
          <div
            style={{
              border: '1px solid #b5b3b3',
            }}
            className="p-1  py-3 rounded-t-sm  flex items-center "
          >
            <div className="px-1 ">From</div>

            <GeniusReportsDate
              date={fromDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 pl-2 ">To</div>
            <GeniusReportsDate
              date={toDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>
          <div style={{ border: '1px solid #b5b3b3', borderTop: '0px' }}>
            {userType === 'USER' ? null : (
              <div className="flex  text-[#4B4545] p-2  ">
                <div
                  
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
               
               
                  <div>
                    <button
                      onClick={okButton}
                      className="flex items-center rounded-sm ml-2"
                      style={{
                        backgroundColor: '#c1c1c1',
                        paddingLeft: 30,
                        paddingRight: 30,
                        paddingTop: 4,
                        paddingBottom: 4,
                        color: 'black',
                      }}
                    >
                      <div className="flex items-center text-sm">Ok</div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div
          style={{
            border: '1px solid #b5b3b3',
            width:columns.reduce(
              (total, row) => Number(total) + Number(row.width),
              0
            )
          }}
          className=" pl-2 rounded-sm flex items-center "
        >
          <div className=" rounded-sm  flex items-center ">
            <div className="px-1 text-[13px]">From</div>

            <GeniusReportsDate
              date={fromDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="mx-4 ">To</div>
            <GeniusReportsDate
              date={toDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>

          <div
            style={{
              borderLeft: '1px solid #b5b3b3',
            }}
            className="flex px-4  ml-5 text-[#4B4545] p-3  "
          >
            <div
              style={{ fontSize: 13 }}
              className=" flex whitespace-normal  justify-center items-center  "
            >
           
           
              <div className="flex">
                <button
                  onClick={okButton}
                  className="flex items-center rounded-sm ml-2"
                  style={{
                    backgroundColor: '#c1c1c1',
                    paddingLeft: 30,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: 'black',
                  }}
                >
                  <div className="flex items-center text-sm">Ok</div>
                </button>
                {list[0] && (
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <button
                          style={{
                            width: 'auto',
                            borderRadius: '7px',
                            height: 'auto',
                            paddingLeft: 30,
                            paddingRight: 30,
                            paddingTop: 4,
                            paddingBottom: 4,
                            marginLeft: 7,
                            backgroundColor: '#bad4f9',
                            color: 'black',
                          }}
                        >
                          <div className="text-sm">Print</div>
                        </button>
                      );
                    }}
                    content={() => printRef.current}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        style={
          windowWidth > 768
            ? {
                height: `calc(100% - 220px)`,

                width:columns.reduce(
                  (total, row) => Number(total) + Number(row.width),
                  0
                )
              }
            : {
                height: `calc(100% - 220px)`,
              }
        }
        className="mt-2 w-full "
      >
        <ReportDataTable
          columns={columns}
          rows={list}
          getRowKey={(row, index) => `${row.NAME || ''}-${row.MOBILE || ''}-${index}`}
          emptyTitle="No non purchasing parties found"
          emptyDescription="Run the report to view parties with no purchases."
        />
      </div>

      <div
        style={
          windowWidth > 768
            ? {
                border: '0px solid #b5b3b3',

                width: columns.reduce(
                  (total, row) => Number(total) + Number(row.width),
                  0
                ),
              }
            : {
                border: '0px solid #b5b3b3',
              }
        }
        className="mt-2 flex justify-end"
      >
        <div
          ref={printRef}
          style={{ width: '100%', display: 'block', visibility: 'hidden' }}
        >
          <GeniusTableReports
        
            columns={columns}
            data={list}
            headerWidth={'80px'}
            title={'Non Purchasing Parties'}
          />
        </div>
      </div>

      <ModListStationMaster
        onRowClick={(p) => {
          setList([]);
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
    </div>
  );
};

export default NonPurchasingParties;
